import { useEffect } from "react";
// @ts-ignore
import OrganizationChart from "@dabeng/react-orgchart";
import MyNode from "./Unit";

import { useBaseData } from "@hooks/useBaseData";
import { useMasterData } from "@hooks/useMasterData";

import { BASE_DATA } from "@constants/base-data";
import { MASTER_DATA } from "@constants/master-data";

import { useCenteredTree } from "@helpers/centeredTree";
import { getPositionColor } from "@helpers/getPositionColor";

import "./style.scss";

const { UNIT_TREE, POSITIONS } = BASE_DATA;
const { POST_TYPE } = MASTER_DATA;

function OrgChart() {
  const { data: positions } = useBaseData(POSITIONS);
  const { data: unitTree } = useBaseData(UNIT_TREE);
  const { data: postType } = useMasterData(POST_TYPE);

  const f = (unit: any) => {
    if (unit.children) {
      const selectedPositions = positions
        ? positions.filter(
            (position: any) => unit.id === `unit-${position.unit.id}`,
          )
        : [];

      const selectedPositionsWithColor = selectedPositions.map(
        (position: any) => {
          return {
            ...position,
            color: getPositionColor(postType, position),
          };
        },
      );

      unit.positions = selectedPositionsWithColor;
      unit.id = `unit-${unit.id}`;

      for (let i = 0; i < unit.children.length; i++) {
        f(unit.children[i]);
      }
    } else return;
  };

  unitTree.length && f(unitTree[0]);
  const [dimensions, translate, containerRef] = useCenteredTree();

  useEffect(() => {
    var element = document.querySelector(`[id*="7"]`);
    // console.log(unitTree, element, element?.clientWidth, element?.scrollWidth)
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [{ ...unitTree[0] }]);

  return (
    <div ref={containerRef as any} className="p-10">
      <div
        className={`p-10 ${translate.x} ${translate.y} shadow-lg border`}
        style={{
          transform: `translate(-${translate.x}px , -${translate.y}px})`,
        }}
      >
        {!!unitTree.length && (
          <OrganizationChart
            datasource={unitTree[0]}
            chartClass="myChart"
            NodeTemplate={MyNode}
            pan={true}
            zoom={true}
            draggable={true}
          />
        )}
      </div>
    </div>
  );
}

export default OrgChart;
